import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-monuments',
  templateUrl: './monuments.component.html',
  styleUrls: ['./monuments.component.css']
})
export class MonumentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
